import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import React, { useState } from "react";
import Error from "../../../ErrorPages/Error";
import { useNavigate, useSearchParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";

const ReturnedSlipTable = () => {
    const navigate = useNavigate();
    const privileges = secureLocalStorage.getItem("privileges");
    const [searchParams, setSearchParams] = useSearchParams();

    const initialEntries = Number(searchParams.get("entries")) || 10;
    const initialPage = Number(searchParams.get("page")) || 1;
    const { useFetch: useFetchDailyPlan } = useAPIQuery({
        key: "daily-plan",
        endpoint: "/api/daily-plan/",
    });

    const [pageIndex, setPageIndex] = useState(initialPage - 1);
    const [entries, setEntries] = useState(initialEntries);
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [columnFilterKey, setColumnFilterKey] = useState("");
    const [columnFilterValue, setColumnFilterValue] = useState("");
    const [sorting, setSorting] = useState([]);
    const {
        data: dailyPlans,
        isLoading: dailyPlansLoading,
        isFetching: fetchingDailyPlans,
        isError: errorLoadingDailyPlans,
    } = useFetchDailyPlan({
        params: {
            entries: entries,
            page_no: pageIndex + 1,
            q: globalFilterValue !== "" ? globalFilterValue : columnFilterValue,
            c: globalFilterValue === "" ? columnFilterKey : "",
            action: "date_view",
            asc:
                sorting &&
                sorting
                    ?.filter((item) => !item?.desc)
                    ?.map((item) => item?.id)
                    ?.join(","),
            desc:
                sorting &&
                sorting
                    ?.filter((item) => item?.desc)
                    ?.map((item) => item?.id)
                    ?.join(","),
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });
    const columns = [
        {
            accessor: "date",
            header: "Date",
            sortable: true,
        },
        privileges.includes("view_returned_slip") && {
            accessor: "view",
            header: "View",
            cell: (row) => (
                <button
                    className="btn btn-sm btn-secondary"
                    onClick={() =>
                        navigate("/return-slip-details", {
                            state: {
                                data: row,
                            },
                        })
                    }
                >
                    View
                </button>
            ),
        },
    ].filter(Boolean);

    const handlePagination = (value) => {
        setSearchParams((prev) => ({
            ...Object.fromEntries(prev.entries()),
            entries: value.pageSize,
            page: value.pageIndex + 1,
        }));
        setPageIndex(value.pageIndex);
        setEntries(value.pageSize);
    };
    const handleGlobalFilterChange = (value) => {
        setGlobalFilterValue(value);
    };
    const handleColumnFilterChange = (value) => {
        setColumnFilterKey(
            value
                .filter((item) => item.value)
                .map((item) => item.id)
                .join(",")
        );
        setColumnFilterValue(
            value
                .filter((item) => item.value)
                .map((item) => item.value)
                .join(",")
        );
    };

    const handleSortingChnage = (value) => {
        setSorting(value);
    };

    if (errorLoadingDailyPlans) return <Error />;
    return (
        <React.Fragment>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">
                            Return Slip
                        </h3>
                    </div>
                </div>
            </div>
            <Table
                data={
                    dailyPlans
                        ? [
                              ...(dailyPlans?.results?.data ?? []),
                              ...((dailyPlans?.results?.machine ?? []).map(
                                  (m) => ({
                                      machine: {
                                          item: {
                                              item_name: m?.item__item_name,
                                          },
                                      },
                                  })
                              ) ?? []),
                          ]
                        : []
                }
                columns={columns}
                isLoading={dailyPlansLoading || fetchingDailyPlans}
                pagination
                pageIndex={pageIndex}
                pageSize={entries}
                rowCount={dailyPlans ? dailyPlans?.count : 0}
                selectRows={false}
                filterModal={false}
                editRows={false}
                deleteRows={false}
                onPaginationChange={handlePagination}
                onGlobalFilterChange={handleGlobalFilterChange}
                onColumnFilterChange={handleColumnFilterChange}
                onSortingChange={handleSortingChnage}
            />
        </React.Fragment>
    );
};

export default ReturnedSlipTable;
